import {niuLabel} from '../utils/niuniu';
export function NiuValue({value}) {
 return <span className={`niu-value niu-level-${value}`}>{niuLabel(value)}</span>;
}
